import { getName } from '@home/utils/common';
import { dynamicString } from '@home/utils/dynamicString';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';
import { getLastNonEmptyIndex } from '@/pages/dashboard/components/Chart/_config/utils';
import { COMPETITOR_COLOR_ARR } from '../constant';

// 创建颜色映射和图例数据
export const createColorMapAndLegend = ({
  currentTab,
  isEN,
  selectedSegment,
  data,
  competitorList
}: any) => {
  if (!currentTab?.componentMetrics) {
    return { colorMap: {}, legendData: [], colorArr: [] };
  }

  const colorMap: any = {};
  const legendData: string[] = [];
  const colorArr: string[] = [];
  
  if (selectedSegment === 'forecast') {
    // forecast模式：使用配置的metrics
    currentTab.componentMetrics.forEach((metric: any) => {
      const name = getName(isEN, metric.enName, metric.cnName);
      colorMap[name] = metric.color;
      legendData.push(name);
      colorArr.push(metric.color);
    });
  } else if (selectedSegment === 'competitor') {
    // competitor模式：先添加current_sales，再添加竞品数据
    const currentSalesMetric = currentTab.componentMetrics.find((m: any) => m.metricKey === 'current_sales');
    if (currentSalesMetric) {
      const currentSalesName = getName(isEN, currentSalesMetric.enName, currentSalesMetric.cnName);
      colorMap[currentSalesName] = currentSalesMetric.color;
      legendData.push(currentSalesName); // current_sales 放在第一位
      colorArr.push(currentSalesMetric.color);
    }

    // 添加竞品数据 - 基于data中的metrics动态生成
    if (data?.list?.length && competitorList?.length) {
      const firstItem = data.list[0];
      const availableMetrics = Object.keys(firstItem.metrics || {});
      const defaultColors = COMPETITOR_COLOR_ARR;
      
      competitorList.forEach((competitor: { combined_id: string; game_name: string; }, index: number) => {
        const { combined_id: competitorKey, game_name: competitorName } = competitor;
    
        // 判断该 competitor 是否在 metrics 中
        if (availableMetrics.includes(competitorKey)) {
          const competitorColor = defaultColors[index % defaultColors.length];
    
          colorMap[competitorName] = competitorColor;
          legendData.push(competitorName);
          colorArr.push(competitorColor);
        }
      });
    }
  }
  
  return { colorMap, legendData, colorArr };
};

// 处理基础数据
export const processBaseData = ({
  data,
  isEN,
  subTitleEn,
  subTitleCn,
  formatRule
}: any) => {
  if (!data?.list?.length) return { subTitle: "", tableDateMap: {}, lastDate: "" };
  
  const list = data?.list || [];
  const xData: any = [];
  const newData: any = [];
  const tableDateMap: any = {};
  
  list?.forEach((item: any, index: number) => {
    xData?.push(item?.date);
    newData?.push(item?.metrics?.current_sales?.value || "");
    if (item?.label && index !== 0) {
      tableDateMap[item?.date] = item?.label;
    }
  });
  
  const lastIndex = getLastNonEmptyIndex(newData);
  const lastDate = xData?.[lastIndex];
  const lastOriginData = newData?.[lastIndex];
  const lastData = dataFormat({ value: newData?.[lastIndex], formatRule });
  const subTitle = dynamicString((getName(isEN, subTitleEn, subTitleCn)), { date: lastDate, lastData, list, xData, lastIndex });
  tableDateMap[lastDate] = lastDate;
  
  return { subTitle, tableDateMap, lastDate, lastData, xData, lastOriginData };
};

// 处理日期映射
export const processDateMap = (data: any) => {
  const list = data?.list || [];
  const dateMap: any = {};
  const tooltipDateMap: any = {};
  
  list.forEach((item: any, index: number) => {
    if (item?.label) {
      dateMap[item?.date] = item?.label;
      tooltipDateMap[item?.date] = index === 0 ? item?.date : item?.label;
    }
  });
  
  return { dateMap, tooltipDateMap };
};
